import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import loader from '../editor/editor.loader';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ISession } from '../../../models/session';
import { IEmailContent } from '../../../models/emailContent';
import { ICampaign } from '../../../models/campaign';
import { OndemandEmailService } from '../../sessions/ondemand-email.service';
import { UsersService } from '../../sessions/users/users.service';
import { CampaignsService } from '../../sessions/campaigns.service';

@Component({
  selector: 'ondemand-editor',
  templateUrl: './ondemand-editor.component.html',
  styleUrls: ['../email.component.scss']
})
export class OndemandEditorComponent implements OnInit {
  @ViewChild('testMailModal') testMailModal: TemplateRef<any>;

  @Input() session: ISession;
  @Input() completions = [];

  public content: IEmailContent = { subject: '', fromName: '', content: '' };
  public saved = true;
  public isLoading = false;
  public isSaving = false;
  public isLoadingPreview = false;
  public testAddress = '';
  public modalRef: BsModalRef;
  public mailingEmails: string[] = [];
  public sendCampaign: ICampaign = null;

  constructor(
    private readonly ondemandEmailService: OndemandEmailService,
    private readonly translateService: TranslateService,
    private readonly modalService: BsModalService,
    private readonly usersService: UsersService,
    private readonly campaignsService: CampaignsService,
  ) {}

  @ViewChild('sendModal') sendModal: TemplateRef<any>;

  ngOnInit() {
    this.load();
  }

  public load() {
    if (!this.session) return;
    this.isLoading = true;
    this.ondemandEmailService.getEmailContent(this.session).subscribe(
      data => {
        this.content = data || { subject: '', fromName: '', content: '' };
        this.isLoading = false;
        this.saved = true;
      },
      _err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.isLoading = false;
      }
    );
  }

  public save() {
    this.isSaving = true;
    this.ondemandEmailService.saveEmailContent(this.session, this.content).subscribe(
      () => {
        this.isSaving = false;
        this.saved = true;
      },
      _err => {
        this.isSaving = false;
      }
    );
  }

  public openModal(template: TemplateRef<any>) {
    if (this.modalRef) this.modalRef.hide();
    this.modalRef = this.modalService.show(template, { class: 'inmodal modal-lg' });
  }

  public openSendModal() {
    this.sendCampaign = { name: '', mode: 'immediate', session_id: +this.session.id, mailing_list: [] };
    this.usersService.getRegisteredUsers(this.session.id).subscribe(
      (users: any[]) => {
        this.mailingEmails = (users || []).map(u => u.Email).filter(e => !!e);
      },
      _err => toastr.error(this.translateService.instant('action.failed'))
    );
    this.openModal(this.sendModal);
  }

  public showPreview() {
    this.isLoadingPreview = true;
    const preview = open('', this.content.subject, 'height=650,width=700');
    if (!preview) { this.isLoadingPreview = false; return; }
    preview.document.write(loader);
    this.ondemandEmailService.previewEmailContent(this.session).subscribe(
      ( content: any ) => {
        preview.document.body.innerHTML = '';
        preview.document.write(content);
        this.isLoadingPreview = false;
      },
      _err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.isLoadingPreview = false;
        preview.close();
      }
    );
  }

  public submitSend() {
    if (!this.sendCampaign || !this.sendCampaign.name) return;
    this.campaignsService.create(this.session, this.sendCampaign, false).subscribe(
      () => {
        this.modalRef.hide();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/ondemand-editor/ondemand-editor.component.ts